import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

interface LayoutPageProps {
    list: { description: string }[],
    listStages: { description: string }[],
}

const MarkerText: React.FC<LayoutPageProps> = ({ list, listStages }) => {
    return (
        <div className="aimed-marker-text">
            <FullWrapper>
                <div className="aimed-marker-textWrapper">
                    <div className="aimed-marker-textPirpleBlock">
                        <div className="aimed-marker-textParagraf">
                            Основой третьего этапа стала разработка и&nbsp;взаимодействие всех
                            модулей платформы, отвечающих за&nbsp;точность и&nbsp;скорость сравнения
                            данных во&nbsp;время проведения конкурса с&nbsp;эталонами.
                        </div>
                    </div>
                    <div className="aimed-marker-textList">
                        {list &&
                            list.map(item => (
                                <div
                                    className="aimed-marker-textParagraf"
                                    key={item.description}
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                ></div>
                            ))}
                    </div>
                    <div className="aimed-marker-textPirpleBlock">
                        <div className="aimed-marker-textParagraf">
                            Четвертый этап&nbsp;&mdash; это подготовка к&nbsp;старту отборочных
                            и&nbsp;финальных конкурсных испытаний, где основной фокус был
                            на&nbsp;обеспечении работоспособности платформы
                            и&nbsp;ее&nbsp;отказоустойчивость в&nbsp;день проведения испытаний
                            в&nbsp;онлайн-режиме.
                        </div>
                    </div>
                    <div className="aimed-marker-textList">
                        {listStages &&
                            listStages.map(item => (
                                <div
                                    className="aimed-marker-textParagraf"
                                    key={item.description}
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                ></div>
                            ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default MarkerText;